import axios from "axios";
import { GeocodeResult } from "./GeocodeResult";
import { ServerError } from "./define/ServerError";

/**
 * APIベースURL
 */
const URL_API = process.env.VUE_APP_GEOCODE_API_URL;

/**
 * Geocodeアクセサクラス
 */
export class GeocodeAccessor {
  /**
   * Geocode検索結果出力メソッド
   */
  async search(word: string): Promise<GeocodeResult[]> {
    const url = URL_API + "?addr=" + word + "&charset=UTF8";
    const res = await axios
      .get(url, {
        responseType: "document",
      })
      .catch((error) => {
        throw new ServerError(
          url,
          error.response?.status,
          error.response.message
        );
      });
    if (!res) {
      return;
    }
    //xml形式レスポンスを基に、geocodeResultを返却
    const candidates = res.data.children[0].getElementsByTagName("candidate");
    const geocodeResultList: GeocodeResult[] = [];
    for (let i = 0; i < candidates.length; i++) {
      const address =
        candidates[i].getElementsByTagName("address")[0].innerHTML;
      const longitude =
        candidates[i].getElementsByTagName("longitude")[0].innerHTML;
      const latitude =
        candidates[i].getElementsByTagName("latitude")[0].innerHTML;
      const geocodeResult = new GeocodeResult(address, longitude, latitude);
      geocodeResultList.push(geocodeResult);
    }
    return geocodeResultList;
  }
}
